import { MarketplacePlugin } from '__pages/Marketplace/types';
import { SetupAssistantRow } from './inputs/Row';
import { useTranslation } from 'react-i18next';
import { Typography } from '@kizen/kds/Typography';
import {
  getActionContainerKey,
  getActionMenuFieldKey,
  getFieldFromAction,
} from '@kizenapps/engine/util';
import { useSetupAssistant } from '@kizenapps/engine/react';
import { AssistantField } from '@kizenapps/engine';

type ActionMappingProps = {
  config: MarketplacePlugin;
  disabled?: boolean;
};

export const ActionMapping = (props: ActionMappingProps) => {
  const { config, disabled = false } = props;
  const { t } = useTranslation();

  const { state } = useSetupAssistant();

  return (
    <>
      <Typography variant="header" size="xl" weight="semibold">
        {t('Link Record Actions to Custom Objects')}
      </Typography>
      <Typography>
        {t(
          'This app includes single-record actions that can be linked to specific custom objects.'
        )}
      </Typography>
      {config.base_config?.setup_assistant?.actions
        ?.slice()
        .sort((a, b) => String(a.name).localeCompare(String(b.name)))
        .map((action) => {
          const fieldConfig = getFieldFromAction(action);

          const fieldKey = fieldConfig.key;
          const booleanContainerKey = getActionContainerKey(action.api_name);

          const linkedObjects = (
            ((state[fieldKey] as any)?.value || []) as Array<{
              id: string;
              objectName: string;
            }>
          )
            .slice()
            .sort((a, b) =>
              String(a.objectName).localeCompare(String(b.objectName))
            );

          const menuFields: AssistantField[] = linkedObjects.map((obj) => ({
            type: 'boolean',
            expandedLabel: obj.objectName,
            label: t('Show in the entity action menu'),
            key: getActionMenuFieldKey(action.api_name, obj.id),
            expanded: true,
            indentLevel: 1,
          }));

          const fields: AssistantField[] = [
            {
              ...fieldConfig,
              label: t('Link to the following object(s):'),
              key: fieldKey,
            },
            ...menuFields,
          ];

          return (
            <SetupAssistantRow
              field={{
                type: 'container',
                columns: 1,
                label: action.name,
                key: booleanContainerKey,
                fields,
              }}
              key={`container__${action.api_name}`}
              pluginApiName={config.api_name}
              disabled={disabled}
            />
          );
        }) ?? null}
    </>
  );
};
